import axios from '@/lib/axios';
import { FacilityLensOrderParams } from '../types';

const createFacilityLens = (data: FacilityLensOrderParams) => {
  return axios.post('/facility/orders/facility_lens', data);
}

export default createFacilityLens;